import React, { useState } from 'react';
import { ManageUsersPanel } from './SuperAdminPanel';
import { UserSignupForm } from './UserSignupForm';

export function AddManageInternalUsersPanel({ onBack, createOpen, onCreateOpenChange }) {
  const [reloadKey, setReloadKey] = useState(0);

  if (createOpen) {
    return (
      <UserSignupForm
        onBack={() => onCreateOpenChange(false)}
        backLabel="← Back to internal user list"
        internalOnly
        onCreated={() => {
          onCreateOpenChange(false);
          setReloadKey((key) => key + 1);
        }}
      />
    );
  }

  return (
    <ManageUsersPanel
      onBack={onBack}
      reloadKey={reloadKey}
      title="Add / Manage internal users"
      description="Manage internal users and supervisors."
      showHeaderFilters
    />
  );
}
